import React, { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import { Plus, Edit2, Trash2, Tag as TagIcon } from "lucide-react";
import { Modal } from "./Brands";

const today = new Date().toISOString().slice(0, 10);
const in60 = new Date(Date.now() + 60 * 86400e3).toISOString().slice(0, 10);
const empty = { brand_id: "", title: "", description: "", image_url: "", start_date: today, end_date: in60, status: "active" };

export default function Offers() {
  const [items, setItems] = useState([]);
  const [brands, setBrands] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState(empty);

  const load = () => api.get("/offers").then((r) => setItems(r.data));
  useEffect(() => { load(); api.get("/brands").then(r => setBrands(r.data)); }, []);

  const save = async (e) => {
    e.preventDefault();
    const payload = { ...form, start_date: new Date(form.start_date).toISOString(), end_date: new Date(form.end_date).toISOString() };
    if (modal === "new") await api.post("/offers", payload);
    else await api.patch(`/offers/${modal}`, payload);
    setModal(null); load();
  };

  return (
    <Layout title="Offers" subtitle="Deals"
      action={<button className="btn-dark flex items-center gap-2" onClick={() => { setForm(empty); setModal("new"); }} data-testid="add-offer-btn"><Plus size={14} /> New offer</button>}>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map((o) => (
          <div key={o.id} className="card-sharp p-6 flex flex-col" data-testid={`offer-card-${o.id}`}>
            <div className="flex items-start justify-between mb-4">
              <div>
                <div className="label-tiny">{o.brand_name}</div>
                <div className="text-lg font-light mt-1" style={{fontFamily:"Outfit"}}>{o.title}</div>
              </div>
              <div className="w-9 h-9 bg-[#E5DAC8] flex items-center justify-center"><TagIcon size={14} className="text-[#6B5634]" /></div>
            </div>
            <p className="text-sm text-[#595959] flex-1">{o.description}</p>
            <div className="flex items-center justify-between mt-5 pt-4 border-t border-[#E6E4E0]">
              <div className="text-[11px] text-[#8C8C8C]">Until {o.end_date?.slice(0,10)}</div>
              <span className={`badge badge-${o.status}`}>{o.status}</span>
            </div>
            <div className="flex gap-2 mt-3">
              <button className="btn-outline flex-1 flex items-center justify-center gap-2" onClick={() => { setForm({ ...o, start_date: o.start_date?.slice(0,10), end_date: o.end_date?.slice(0,10) }); setModal(o.id); }}><Edit2 size={12} /> Edit</button>
              <button className="btn-outline" onClick={async () => { if (confirm("Delete?")) { await api.delete(`/offers/${o.id}`); load(); } }}><Trash2 size={12} /></button>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="col-span-full text-center py-12 text-[#8C8C8C]">No offers yet.</div>}
      </div>

      {modal && (
        <Modal onClose={() => setModal(null)} title={modal === "new" ? "New offer" : "Edit offer"}>
          <form onSubmit={save} className="space-y-4">
            <div><div className="label-tiny mb-1.5">Brand</div>
              <select className="fin" required value={form.brand_id} onChange={(e) => setForm({...form, brand_id: e.target.value})} data-testid="offer-brand">
                <option value="">— select —</option>
                {brands.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
              </select>
            </div>
            <div><div className="label-tiny mb-1.5">Title</div><input className="fin" required value={form.title} onChange={(e) => setForm({...form, title: e.target.value})} data-testid="offer-title" /></div>
            <div><div className="label-tiny mb-1.5">Description</div><textarea className="fin" rows="3" value={form.description} onChange={(e) => setForm({...form, description: e.target.value})} data-testid="offer-desc" /></div>
            <div className="grid grid-cols-2 gap-3">
              <div><div className="label-tiny mb-1.5">Start</div><input type="date" className="fin" value={form.start_date?.slice(0,10)} onChange={(e) => setForm({...form, start_date: e.target.value})} /></div>
              <div><div className="label-tiny mb-1.5">End</div><input type="date" className="fin" value={form.end_date?.slice(0,10)} onChange={(e) => setForm({...form, end_date: e.target.value})} /></div>
            </div>
            <div><div className="label-tiny mb-1.5">Image URL (optional)</div><input className="fin" value={form.image_url||""} onChange={(e) => setForm({...form, image_url: e.target.value})} /></div>
            <div><div className="label-tiny mb-1.5">Status</div>
              <select className="fin" value={form.status} onChange={(e) => setForm({...form, status: e.target.value})}>
                <option value="active">Active</option><option value="inactive">Inactive</option>
              </select>
            </div>
            <div className="flex justify-end gap-2 pt-2">
              <button type="button" className="btn-outline" onClick={() => setModal(null)}>Cancel</button>
              <button type="submit" className="btn-dark" data-testid="save-offer-btn">Save</button>
            </div>
          </form>
        </Modal>
      )}
    </Layout>
  );
}
